import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../redux/store';
import { selectIsCorporateParent, selectCustomer } from '../redux/customer';
import { selectIsAdminOrOwner, selectCurrentUser } from '../redux/user';
import LoadingScreen from './LoadingScreen';

const DashboardRedirect: React.FC = () => {
  const navigate = useNavigate();
  const [redirectAttempted, setRedirectAttempted] = useState(false);
  const [hasTimedOut, setHasTimedOut] = useState(false);
  
  const isCorporateParent = useAppSelector(selectIsCorporateParent);
  const isAdminOrOwner = useAppSelector(selectIsAdminOrOwner);
  const customer = useAppSelector(selectCustomer);
  const currentUser = useAppSelector(selectCurrentUser);

  // Check if data is loaded
  const isDataLoaded = customer && currentUser && 
    customer.customer_number && 
    currentUser.access_level !== undefined;

  useEffect(() => {
    // Set a timeout to prevent infinite loading
    const timeoutId = setTimeout(() => {
      if (!isDataLoaded) {
        console.warn('DashboardRedirect - Timed out waiting for data, redirecting to support');
        setHasTimedOut(true);
        navigate('/support');
      }
    }, 10000); // 10 second timeout

    if (!isDataLoaded) {
      return () => clearTimeout(timeoutId);
    }

    // Clear timeout since data is loaded
    clearTimeout(timeoutId);

    // Prevent multiple redirect attempts
    if (redirectAttempted) {
      return;
    }

    setRedirectAttempted(true);

    if (isCorporateParent && isAdminOrOwner) {
      navigate('/corp/dashboard');
    } else {
      navigate('/practice/dashboard');
    }
  }, [isCorporateParent, isAdminOrOwner, isDataLoaded, navigate, redirectAttempted]);

  if (!isDataLoaded && !hasTimedOut) {
    return (
      <LoadingScreen />
    );
  }

  // If we've timed out, don't render anything
  if (hasTimedOut) {
    navigate('/support');
  }

  // This should never render since we navigate in useEffect, but just in case
  return null;
};

export default DashboardRedirect;
